import { render, staticRenderFns } from "./AffiliateCompaniesCard.vue?vue&type=template&id=3d2db310&"
import script from "./AffiliateCompaniesCard.vue?vue&type=script&lang=js&"
export * from "./AffiliateCompaniesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports